// authorUtils.ts - Runtime functions for author information management
import type { AuthorDetails, BackMatter } from '../types/core';

// Helper functions for author information consolidation (eliminating redundant BackMatter author fields)
export const getAuthorBioForBackMatter = (authorDetails?: AuthorDetails): string => {
    return authorDetails?.authorBio || '';
};

export const getAuthorContactForBackMatter = (authorDetails?: AuthorDetails): string => {
    return authorDetails?.authorContact || '';
};

// Generate professional "About the Author" section from structured AuthorDetails
export const generateAboutTheAuthorSection = (authorDetails?: AuthorDetails): string => {
    if (!authorDetails) return '';

    let aboutSection = '';

    // Add author bio if available
    if (authorDetails.authorBio) {
        aboutSection += authorDetails.authorBio;
    }

    // Add contact/social information if available
    if (authorDetails.authorContact) {
        if (aboutSection) aboutSection += '\n\n';
        aboutSection += authorDetails.authorContact;
    }

    return aboutSection;
};

// Generate professional contact/social media section from structured AuthorDetails
export const generateContactSocialMediaSection = (authorDetails?: AuthorDetails): string => {
    if (!authorDetails) return '';

    let contactSection = '';

    // Add website if available
    if (authorDetails.authorWebsite) {
        contactSection += `**Website:** ${authorDetails.authorWebsite}\n\n`;
    }

    // Add social media links if available
    if (authorDetails.authorSocialMedia) {
        contactSection += authorDetails.authorSocialMedia;
    }

    // Add general contact info if available and different from social media
    if (authorDetails.authorContact && authorDetails.authorContact !== authorDetails.authorSocialMedia) {
        if (contactSection) contactSection += '\n\n';
        contactSection += '**Contact:** ' + authorDetails.authorContact;
    }

    return contactSection;
};

// Consolidate BackMatter author fields to use structured data (removes redundancy)
export const consolidateBackMatterAuthorInfo = (backMatter: BackMatter, authorDetails?: AuthorDetails): BackMatter => {
    return {
        ...backMatter,
        aboutTheAuthor: generateAboutTheAuthorSection(authorDetails),
        contactSocialMedia: generateContactSocialMediaSection(authorDetails)
    };
};